/**
 * Shopify Analytics - Theme-level tracking
 * Captures standard customer events directly in the theme to guarantee tracking
 * when Custom Pixel is blocked by ad blockers.
 * Ref: https://shopify.dev/docs/api/web-pixels-api
 *
 * Events: page_viewed, product_viewed, collection_viewed, cart_viewed,
 *         product_added_to_cart, search_submitted
 *
 * Data available in: window.shopifyAnalyticsDataLayer
 * Publishes to: Shopify.analytics.publish (theme:* custom events)
 */
(function () {
  'use strict';

  const PREFIX = 'theme:';
  const SEQ = { n: 0 };

  function nextId() {
    return 'evt_' + Date.now() + '_' + ++SEQ.n;
  }

  function baseEvent(name) {
    return {
      id: nextId(),
      name: name.replace(PREFIX, ''),
      timestamp: new Date().toISOString(),
      seq: SEQ.n,
      context: {
        document: {
          title: document.title,
          referrer: document.referrer || '',
          location: {
            href: location.href,
            pathname: location.pathname,
            search: location.search,
            hostname: location.hostname,
            origin: location.origin
          }
        },
        navigator: {
          language: navigator.language,
          languages: navigator.languages ? Array.from(navigator.languages) : [],
          userAgent: navigator.userAgent,
          cookieEnabled: navigator.cookieEnabled
        },
        window: {
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight
        }
      }
    };
  }

  function pushToDataLayer(event) {
    window.shopifyAnalyticsDataLayer = window.shopifyAnalyticsDataLayer || [];
    window.shopifyAnalyticsDataLayer.push(event);
    try {
      window.dispatchEvent(new CustomEvent('shopify:analytics:event', { detail: event }));
    } catch (e) {}
  }

  function publishToShopify(name, customData) {
    try {
      if (window.Shopify && typeof window.Shopify.analytics === 'object' && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(PREFIX + name, customData || {});
      }
    } catch (e) {}
  }

  function emit(name, data) {
    const evt = {
      ...baseEvent(name),
      data: data || {},
      source: 'theme'
    };
    pushToDataLayer(evt);
    publishToShopify(name, data);
  }

  function init() {
    const pageData = window.shopifyAnalyticsPageData || {};
    const template = pageData.template || '';

    // page_viewed - every page
    emit('page_viewed', {
      page: {
        title: pageData.pageTitle || document.title,
        type: template
      }
    });

    // product_viewed
    if (template === 'product' && pageData.productVariant) {
      emit('product_viewed', {
        productVariant: pageData.productVariant
      });
    }

    // collection_viewed
    if (template === 'collection' && pageData.collection) {
      emit('collection_viewed', {
        collection: pageData.collection
      });
    }

    // cart_viewed
    if (template === 'cart' && pageData.cart) {
      emit('cart_viewed', {
        cart: pageData.cart
      });
    }

    // search_submitted - on search form submit
    const searchForm = document.querySelector('form[action*="/search"], form[role="search"]');
    if (searchForm) {
      searchForm.addEventListener('submit', function () {
        const input = searchForm.querySelector('input[name="q"], input[type="search"]');
        const query = input ? (input.value || '').trim() : '';
        if (query) {
          emit('search_submitted', {
            search: {
              query: query
            }
          });
        }
      });
    }

    // product_added_to_cart - via pubsub cartUpdate
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (!payload || payload.source === 'cart-items') return;
        const cartData = payload.cartData;
        const productVariantId = payload.productVariantId;
        if (!cartData || !productVariantId) return;

        const items = cartData.items || [];
        const addedLine = items.find(function (line) {
          return String(line.variant_id) === String(productVariantId) || String(line.id) === String(productVariantId);
        });

        if (addedLine) {
          var priceCents = addedLine.price || addedLine.final_price || 0;
          var linePriceCents = addedLine.line_price || addedLine.final_line_price || priceCents * addedLine.quantity;
          var currency = cartData.currency || 'BRL';
          var imgSrc = addedLine.image || (addedLine.featured_image && addedLine.featured_image.url);
          var productId = addedLine.product_id || addedLine.productId;
          var cartLine = {
            quantity: addedLine.quantity,
            merchandise: {
              id: 'gid://shopify/ProductVariant/' + addedLine.variant_id,
              title: (addedLine.variant_title || addedLine.title || '').trim() || addedLine.product_title,
              sku: addedLine.sku || null,
              price: {
                amount: typeof priceCents === 'number' ? priceCents / 100 : parseFloat(priceCents) || 0,
                currencyCode: currency
              },
              product: {
                id: productId ? 'gid://shopify/Product/' + productId : null,
                title: addedLine.product_title || addedLine.title,
                url: addedLine.url || null,
                vendor: addedLine.vendor || null,
                type: addedLine.product_type || null
              },
              image: imgSrc ? { src: imgSrc } : null
            },
            cost: {
              totalAmount: {
                amount: typeof linePriceCents === 'number' ? linePriceCents / 100 : parseFloat(linePriceCents) / 100 || 0,
                currencyCode: currency
              }
            }
          };
          emit('product_added_to_cart', { cartLine: cartLine });
        }
      });
    }

    // checkout_started - click on checkout button (begin_checkout)
    document.addEventListener('click', function (e) {
      const target = e.target.closest('a[href*="/checkout"], a[href*="checkout.shopify"], button[name="checkout"], [data-checkout]');
      if (target) {
        emit('checkout_started', {
          checkout: {
            token: null,
            source: 'theme'
          }
        });
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
